/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  EIIResponseDTO,
  EIIResponseDTOOptional,
  EIIResponseDTOMetaI,
  EIIResponseDTOTrackedI,
} from "./eiiresponse-dto";
import { EIIResponseDTOTracked, EIIResponseDTOMeta } from "./eiiresponse-dto";

/**
 *
 * @export
 * @interface CurrentEIIResponseDTO
 */
export interface CurrentEIIResponseDTOOptional extends EIIResponseDTOOptional {
  /**
   *
   * @type {number}
   * @memberof CurrentEIIResponseDTO
   */
  workingAdults?: number;
  /**
   *
   * @type {number}
   * @memberof CurrentEIIResponseDTO
   */
  nonWorkingAdults?: number;
  /**
   *
   * @type {number}
   * @memberof CurrentEIIResponseDTO
   */
  children?: number;
  /**
   *
   * @type {number}
   * @memberof CurrentEIIResponseDTO
   */
  householdIncome?: number;
  /**
   *
   * @type {number}
   * @memberof CurrentEIIResponseDTO
   */
  computedPrice?: number;
}

export interface CurrentEIIResponseDTO
  extends CurrentEIIResponseDTOOptional, EIIResponseDTO {
  /**
   *
   * @type {number}
   * @memberof CurrentEIIResponseDTO
   */
  workingAdults: number;
  /**
   *
   * @type {number}
   * @memberof CurrentEIIResponseDTO
   */
  nonWorkingAdults: number;
  /**
   *
   * @type {number}
   * @memberof CurrentEIIResponseDTO
   */
  children: number;
  /**
   *
   * @type {number}
   * @memberof CurrentEIIResponseDTO
   */
  householdIncome: number;
  /**
   *
   * @type {number}
   * @memberof CurrentEIIResponseDTO
   */
  computedPrice?: number;
}

export interface CurrentEIIResponseDTOTrackedI extends EIIResponseDTOOptional {
  /**
   *
   * @type {number}
   * @memberof CurrentEIIResponseDTO
   */
  workingAdults?: number;
  workingAdultsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CurrentEIIResponseDTO
   */
  nonWorkingAdults?: number;
  nonWorkingAdultsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CurrentEIIResponseDTO
   */
  children?: number;
  childrenIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CurrentEIIResponseDTO
   */
  householdIncome?: number;
  householdIncomeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CurrentEIIResponseDTO
   */
  computedPrice?: number;
  computedPriceIsSet: boolean;
}

transformDatesMap.set(
  "CurrentEIIResponseDTO",
  function (model: CurrentEIIResponseDTO) {},
);

export type CurrentEIIResponseDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  workingAdults: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  nonWorkingAdults: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  children: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  householdIncome: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  computedPrice: PropertyMeta<MetaTypeBase<number>>;
}>;

export var CurrentEIIResponseDTOMeta: CurrentEIIResponseDTOMetaI =
  {} as CurrentEIIResponseDTOMetaI;
CurrentEIIResponseDTOMeta = typeMeta("CurrentEIIResponseDTO", {
  workingAdults: propertyMeta(
    "workingAdults",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
  nonWorkingAdults: propertyMeta(
    "nonWorkingAdults",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
  children: propertyMeta("children", false, true, false, MetaTypesBase.number),
  householdIncome: propertyMeta(
    "householdIncome",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
  computedPrice: propertyMeta(
    "computedPrice",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = CurrentEIIResponseDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([EIIResponseDTOMeta]);
  metaI.workingAdults.inheritedFrom = EIIResponseDTOMeta.workingAdults;
  metaI.nonWorkingAdults.inheritedFrom = EIIResponseDTOMeta.nonWorkingAdults;
  metaI.children.inheritedFrom = EIIResponseDTOMeta.children;
  metaI.householdIncome.inheritedFrom = EIIResponseDTOMeta.householdIncome;
});

export class CurrentEIIResponseDTOTracked
  extends EIIResponseDTOTracked
  implements CurrentEIIResponseDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  workingAdults__I?: number = undefined;
  workingAdultsIsSet: boolean = false;
  set workingAdults(v: undefined | number) {
    if (v !== undefined) {
      this.workingAdults__I = v;
      this.workingAdultsIsSet = true;
    } else {
      this.workingAdults__I = v || undefined;
      this.workingAdultsIsSet = true;
    }
    this.changeTracker = true;
  }
  get workingAdults() {
    return this.workingAdults__I;
  }
  nonWorkingAdults__I?: number = undefined;
  nonWorkingAdultsIsSet: boolean = false;
  set nonWorkingAdults(v: undefined | number) {
    if (v !== undefined) {
      this.nonWorkingAdults__I = v;
      this.nonWorkingAdultsIsSet = true;
    } else {
      this.nonWorkingAdults__I = v || undefined;
      this.nonWorkingAdultsIsSet = true;
    }
    this.changeTracker = true;
  }
  get nonWorkingAdults() {
    return this.nonWorkingAdults__I;
  }
  children__I?: number = undefined;
  childrenIsSet: boolean = false;
  set children(v: undefined | number) {
    if (v !== undefined) {
      this.children__I = v;
      this.childrenIsSet = true;
    } else {
      this.children__I = v || undefined;
      this.childrenIsSet = true;
    }
    this.changeTracker = true;
  }
  get children() {
    return this.children__I;
  }
  householdIncome__I?: number = undefined;
  householdIncomeIsSet: boolean = false;
  set householdIncome(v: undefined | number) {
    if (v !== undefined) {
      this.householdIncome__I = v;
      this.householdIncomeIsSet = true;
    } else {
      this.householdIncome__I = v || undefined;
      this.householdIncomeIsSet = true;
    }
    this.changeTracker = true;
  }
  get householdIncome() {
    return this.householdIncome__I;
  }
  computedPrice__I?: number = undefined;
  computedPriceIsSet: boolean = false;
  set computedPrice(v: undefined | number) {
    if (v !== undefined) {
      this.computedPrice__I = v;
      this.computedPriceIsSet = true;
    } else {
      this.computedPrice__I = v || undefined;
      this.computedPriceIsSet = false;
    }
    this.changeTracker = true;
  }
  get computedPrice() {
    return this.computedPrice__I;
  }
  constructor(config?: CurrentEIIResponseDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: CurrentEIIResponseDTOOptional,
    options?: AssignOptions,
  ): CurrentEIIResponseDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.workingAdults &&
      this.workingAdultsApplyFilter(optionsRequired.filter)
    ) {
      this.workingAdults = config.workingAdults;
      if (optionsRequired.unassign) this.workingAdultsIsSet = false;
      else this.workingAdultsIsSet = true;
    }
    if (
      config.nonWorkingAdults &&
      this.nonWorkingAdultsApplyFilter(optionsRequired.filter)
    ) {
      this.nonWorkingAdults = config.nonWorkingAdults;
      if (optionsRequired.unassign) this.nonWorkingAdultsIsSet = false;
      else this.nonWorkingAdultsIsSet = true;
    }
    if (config.children && this.childrenApplyFilter(optionsRequired.filter)) {
      this.children = config.children;
      if (optionsRequired.unassign) this.childrenIsSet = false;
      else this.childrenIsSet = true;
    }
    if (
      config.householdIncome &&
      this.householdIncomeApplyFilter(optionsRequired.filter)
    ) {
      this.householdIncome = config.householdIncome;
      if (optionsRequired.unassign) this.householdIncomeIsSet = false;
      else this.householdIncomeIsSet = true;
    }
    if (
      config.computedPrice &&
      this.computedPriceApplyFilter(optionsRequired.filter)
    ) {
      this.computedPrice = config.computedPrice;
      if (optionsRequired.unassign) this.computedPriceIsSet = false;
      else this.computedPriceIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CurrentEIIResponseDTOTrackedI {
    const cloned = {} as CurrentEIIResponseDTOTrackedI;
    if (
      this.workingAdultsIsSetDeep() &&
      this.workingAdultsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.workingAdultsIsSet = true;
      cloned.workingAdults = this.workingAdults;
    } else {
      //cloned.workingAdultsIsSet = false
    }
    if (
      this.nonWorkingAdultsIsSetDeep() &&
      this.nonWorkingAdultsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.nonWorkingAdultsIsSet = true;
      cloned.nonWorkingAdults = this.nonWorkingAdults;
    } else {
      //cloned.nonWorkingAdultsIsSet = false
    }
    if (
      this.childrenIsSetDeep() &&
      this.childrenApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.childrenIsSet = true;
      cloned.children = this.children;
    } else {
      //cloned.childrenIsSet = false
    }
    if (
      this.householdIncomeIsSetDeep() &&
      this.householdIncomeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.householdIncomeIsSet = true;
      cloned.householdIncome = this.householdIncome;
    } else {
      //cloned.householdIncomeIsSet = false
    }
    if (
      this.computedPriceIsSetDeep() &&
      this.computedPriceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.computedPriceIsSet = true;
      cloned.computedPrice = this.computedPrice;
    } else {
      //cloned.computedPriceIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CurrentEIIResponseDTOTrackedI {
    if (!this.workingAdultsApplyFilter(filter)) this.workingAdultsIsSet = false;

    if (!this.nonWorkingAdultsApplyFilter(filter))
      this.nonWorkingAdultsIsSet = false;

    if (!this.childrenApplyFilter(filter)) this.childrenIsSet = false;

    if (!this.householdIncomeApplyFilter(filter))
      this.householdIncomeIsSet = false;

    if (!this.computedPriceApplyFilter(filter)) this.computedPriceIsSet = false;

    return this;
  }
  workingAdultsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CurrentEIIResponseDTOMeta.workingAdults,
      CurrentEIIResponseDTOMeta,
      this.workingAdults,
      this,
    );
  }
  workingAdultsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.workingAdultsIsSet && this.workingAdultsApplyFilter(filter))
      return true;

    return false;
  }
  nonWorkingAdultsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CurrentEIIResponseDTOMeta.nonWorkingAdults,
      CurrentEIIResponseDTOMeta,
      this.nonWorkingAdults,
      this,
    );
  }
  nonWorkingAdultsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.nonWorkingAdultsIsSet && this.nonWorkingAdultsApplyFilter(filter))
      return true;

    return false;
  }
  childrenApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CurrentEIIResponseDTOMeta.children,
      CurrentEIIResponseDTOMeta,
      this.children,
      this,
    );
  }
  childrenIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.childrenIsSet && this.childrenApplyFilter(filter)) return true;

    return false;
  }
  householdIncomeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CurrentEIIResponseDTOMeta.householdIncome,
      CurrentEIIResponseDTOMeta,
      this.householdIncome,
      this,
    );
  }
  householdIncomeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.householdIncomeIsSet && this.householdIncomeApplyFilter(filter))
      return true;

    return false;
  }
  computedPriceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CurrentEIIResponseDTOMeta.computedPrice,
      CurrentEIIResponseDTOMeta,
      this.computedPrice,
      this,
    );
  }
  computedPriceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.computedPriceIsSet && this.computedPriceApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.workingAdultsIsSetDeep(filter)) return true;
    if (this.nonWorkingAdultsIsSetDeep(filter)) return true;
    if (this.childrenIsSetDeep(filter)) return true;
    if (this.householdIncomeIsSetDeep(filter)) return true;
    if (this.computedPriceIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
